import React, { Component } from 'react'
import { Row, Col, Modal, Input, Select, DatePicker, Spin, message } from 'antd'
import $ from 'jquery';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class NewCarry extends Component {

    constructor( props ){
        super( props );
        
        this.state = {
            visible: false,
            users_list: [],
            user_id: 0,
            carrforward: 0,
            carrforward_year: 0,
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
    
    }

    handleCancel(){
        this.props.onCancel();
        this.setState({
            user_id: 0,
            carrforward: 0,
            carrforward_year: 0,
        });
    }

    componentWillReceiveProps( nextProps ){
        
        this.setState({ visible: nextProps.onVisible, users_list: nextProps.usersList });

    }

    handleOk() {

        if( this.state.user_id === 0 ){
            message.error("Please choose employee name")
            return false
        }

        if( this.state.carrforward === 0 ){
            message.error("Please choose carry forward");
            return false
        }

        if( this.state.carrforward_year === 0 ){
            message.error("Please choose carry forward year");
            return false
        }
        
        let stack = {
            user_id: this.state.user_id,
            carrforward: this.state.carrforward,
            carrforward_year: this.state.carrforward_year,
        }

        this.props.onSubmit( stack );

        this.setState({
            user_id: 0,
            carrforward: 0,
            carrforward_year: 0,
        });

    }

    render() {

        const options = this.state.users_list.map( ( item, key ) => <Option key={ item.user_id }>{ item.full_name }</Option> )

        return (
            <Modal
                title="New Carry Forward"
                maskClosable={ false }
                visible={ this.state.visible }
                onOk={ this.handleOk }
                onCancel={ this.handleCancel }>
                <Row>
                    <Col span={24}>

                        <Row>
                            <Col span={24} >
                                <label className='carry_label'>Employee</label>
                                <Select 
                                    showSearch 
                                    placeholder={ 'Choose Employee' }
                                    style={{ width: '100%' }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={ value => this.setState({ user_id: value}) }
                                    value={ this.state.user_id }>
                                    <Option value={0} disabled>None</Option>
                                    { options }
                                </Select>
                            </Col>
                        </Row>

                        <Row gutter={12}>
                            <Col span={12}>
                                <label className='carry_label'>Carry Forward</label>
                                <Input 
                                    value={ this.state.carrforward }
                                    type='number' onChange={ e => this.setState({ carrforward: e.target.value }) } />
                            </Col>
                            <Col span={12}>
                                <label className='carry_label'>Carry Forward Year</label>
                                <Select
                                    value={ this.state.carrforward_year }
                                    onChange={ value => this.setState({ carrforward_year: value }) }
                                    style={{ width: '100%' }}>
                                    <Option value={0} disabled>None</Option>
                                    <Option key="2014">2014</Option>
                                    <Option key="2015">2015</Option>
                                    <Option key="2016">2016</Option>
                                    <Option key="2017">2017</Option>
                                    <Option key="2018">2018</Option>
                                    <Option key="2019">2019</Option>
                                    <Option key="2020">2020</Option>
                                    <Option key="2021">2021</Option>
                                    <Option key="2022">2022</Option>
                                    <Option key="2023">2023</Option>
                                    <Option key="2024">2024</Option>
                                    <Option key="2025">2025</Option>
                                </Select>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default NewCarry



// WEBPACK FOOTER //
// ./src/pages/individual_carry_forwards/childs/new.carry.js